import Constants from 'config/Constants';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

export function FileBlockOptions({ file }) {
    const { t } = useTranslation();

    const options = getFileBlockOptions(file);
    const { align, description, alt, url, customSize } = options;

    return (
        <div className="ml-3 mt-1 small">
            <div className="text-black mb-2">
                <div className="font-weight-bold">
                    {t('documents:document.navbar.main.editor.left.blocks.types.fileBlock.alignment')}
                </div>
                {Constants.fileBlock.alignOptions[align]}
            </div>

            {_.isEmpty(description) === false && (
                <div className="text-black mb-2">
                    <div className="font-weight-bold">
                        {t('documents:document.navbar.main.editor.left.blocks.types.fileBlock.description')}
                    </div>
                    {description}
                </div>
            )}

            {_.isEmpty(alt) === false && (
                <div className="text-black mb-2">
                    <div className="font-weight-bold">
                        {t('documents:document.navbar.main.editor.left.blocks.types.fileBlock.altText')}
                    </div>
                    {alt}
                </div>
            )}

            {_.isEmpty(url) === false && (
                <div className="text-black mb-2">
                    <div className="font-weight-bold">URL</div>
                    {url}
                </div>
            )}

            <div className="text-black">
                <div className="font-weight-bold">
                    {t('documents:document.navbar.main.editor.left.blocks.types.fileBlock.customDimensions')}
                </div>

                {customSize ? (
                    <>
                        {t('documents:document.navbar.main.editor.left.blocks.types.fileBlock.yes')}
                        <>
                            &nbsp;({options['width']}x{options['height']} pixels)
                        </>
                    </>
                ) : (
                    t('documents:document.navbar.main.editor.left.blocks.types.fileBlock.no')
                )}
            </div>
        </div>
    );
}

const FILE_OPTIONS_DEFAULT_ALIGN = 'left';

const getFileBlockOptions = (file, customOptions) => {
    return _.defaults(customOptions, file?.options ?? {}, {
        align: 'left',
        description: '',
        alt: '',
        url: '',
        customSize: false,
        width: '',
        height: '',
    });
};
